import React from 'react'
import SEO from '../components/common/SEO'
import HeroSection from '../components/home/HeroSection'
import HeroAbout from '../components/home/HeroAbout'
import HeroWhyChoose from '../components/common/HeroWhyChoose'
import HeroCounters from '../components/home/HeroCounters'
import HeroFeaturedProjects from '../components/home/HeroFeaturedProjects'
import WorkProcess from '../components/common/WorkProcess'
import Testimonials from '../components/common/Testimonials'
import FaqSection from '../components/common/FaqSection'
import BlogSection from '../components/home/BlogSection'
import CTASection from '../components/common/CTASection'
import HeroServices from '../components/home/HeroServices'

const Home = () => {
  return (
    <>
      <SEO
        title="AZ Construction | Construction Company & Property Dealer in Indore"
        description="AZ Construction is a trusted construction company in Indore offering residential & commercial construction, property development, property dealing, and liaisoning services with quality craftsmanship and transparent project management."
        keywords="construction company in Indore, builder in Indore, property dealer in Indore, property development, residential construction, commercial construction, liaisoning services, civil contractor, real estate consultant, AZ Construction"
        url="https://azconstruction.com/"
      />
      <HeroSection />
      <HeroAbout />
      <HeroServices />
      <HeroWhyChoose />
      <HeroCounters />
      <HeroFeaturedProjects />
      <WorkProcess />
      <Testimonials />
      <FaqSection />
      <BlogSection />
      <CTASection />
    </>
  )
}

export default Home